// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"95a1e9a0","772":"3c93e732","787":"d0e8f19a"}[chunkId] + ".chunk.js";
};